import { render, staticRenderFns } from "./assistant-message-bubble.vue?vue&type=template&id=ec23fedc&scoped=true"
import script from "./assistant-message-bubble.vue?vue&type=script&lang=js"
export * from "./assistant-message-bubble.vue?vue&type=script&lang=js"
import style0 from "./assistant-message-bubble.vue?vue&type=style&index=0&id=ec23fedc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec23fedc",
  null
  
)

export default component.exports